export type PassivoTipo = 'PFEE' | 'TAXA_ADM' | 'TAXA_CUSTODIA' | 'OUTRO';

export const TIPO_LABEL: Record<PassivoTipo | string, string> = {
  PFEE:          'Taxa de Performance',
  TAXA_ADM:      'Taxa de Administração',
  TAXA_CUSTODIA: 'Taxa de Custódia',
  OUTRO:         'Outro',
};

export const TIPO_CHOICES = Object.entries(TIPO_LABEL).map(([value, label]) => ({ value, label }));

export const CATEGORIA_CHOICES = [
  'Serviços Essenciais',
  'Demais Serviços',
  'Reguladores',
  'Resgates',
];

export interface Passivo {
  id: number;
  descricao: string;
  conta: string;
  tipo: PassivoTipo;
}
